/**
 * @generated SignedSource<<9019f35a27604b1e6b745ca8fcd296ff>>
 * @relayHash 26006e99dda6c8a19ab4ec521aea65b7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 267953d482f6d8ed46adbba8c0b452b9e1f41a005d1fc7086b382519d35bf09b

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessBoardEmbedQuery } from './src_jiraBusinessBoardEmbedQuery.graphql';

import isSavedViewsBoardColumnSettingsEnabled_provider from '@atlassian/jira-relay-provider/src/saved-views-board-column-settings.relayprovider';
import withFiltersAndColumnSettings_provider from '@atlassian/jira-relay-provider/src/saved-views-board-filter-and-column-settings.relayprovider';
import withFilters_provider from '@atlassian/jira-relay-provider/src/saved-views-board-filter-setting.relayprovider';
import withSelectedWorkflow_provider from '@atlassian/jira-relay-provider/src/saved-views-board-selected-workflow-setting.relayprovider';
import isSaveResetViewEnabled_provider from '@atlassian/jira-relay-provider/src/sv-230-save-revert-board-view-settings.relayprovider';

const node: PreloadableConcreteRequest<src_jiraBusinessBoardEmbedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "267953d482f6d8ed46adbba8c0b452b9e1f41a005d1fc7086b382519d35bf09b",
    "metadata": {},
    "name": "src_jiraBusinessBoardEmbedQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcsavedviewsboardcolumnsettingsrelayprovider": isSavedViewsBoardColumnSettingsEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcsavedviewsboardfiltersettingrelayprovider": withFilters_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcsavedviewsboardselectedworkflowsettingrelayprovider": withSelectedWorkflow_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcsavedviewsboardfilterandcolumnsettingsrelayprovider": withFiltersAndColumnSettings_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcsv230saverevertboardviewsettingsrelayprovider": isSaveResetViewEnabled_provider
    }
  }
};

export default node;
